import { BaseClient } from 'src/common-services/clients/base-client'
import { PriceWithCategoryInfo } from 'src/views/pricing-calculator/types'

export class PricingCalculatorClient extends BaseClient {
  getPrices(): Promise<Array<string>> {
    return this.get('/pricing-calculator/prices')
  }
  getCategories(): Promise<Array<PriceWithCategoryInfo>> {
    return this.get(`/pricing-calculator/company-categories`)
  }
}
